import { Stack, Typography, SxProps } from '@mui/material';
import { textSX } from '@/components/blocks/DpLibrary/DpParagraphCustom/style/main';
import { combineSX } from '@/utils/combineSX';

export const DpParagraphCustom = ({
	text,
	sxcontainer,
	...props
}: {
	text: string;
	sxcontainer?: SxProps;
}) => (
	<Stack
		justifyContent={'center'}
		flexDirection={'row'}
		sx={combineSX([
			{ width: '100%' },
			...(Array.isArray(sxcontainer) ? sxcontainer : [sxcontainer]),
		])}
	>
		{text ? (
			<Typography sx={textSX} {...props}>
				{text}
			</Typography>
		) : null}
	</Stack>
);
